import { actions } from './actions';

export const filter = {
  state: {
    artwork: {
      NS_LOCALE: [],
      NS_AUTHOR: [],
      NS_MAIN_GROUP: []
    },
    theme: {
      NS_LOCALE: [],
      NS_TOPIC: []
    },
    temple: {
      NS_LOCALE: [],
      NS_TOPIC: []
    }
  },
  getters: {
    artworkFilter(state) {
      return state.artwork;
    },
    themeFilter(state) {
      return state.theme;
    },
    templeFilter(state) {
      return state.temple;
    }
  },
  mutations: {
    setArtworkFilter(state, payload) {
      state.artwork = payload;
    },
    setThemeFilter(state, payload) {
      state.theme = payload;
    },
    setTempleFilter(state, payload) {
      state.temple = payload;
    },
  },
  actions,
};
